<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      {{ info.id ? "Cập nhật sản phẩm" : "Thêm mới sản phẩm" }}
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col>
              <base-input
                label="Mã sản phẩm"
                placeholder="Nếu không nhập hệ thống sẽ tự sinh"
                v-model="info.code"
              ></base-input>
            </b-col>
            <b-col cols="8">
              <ValidationProvider
                name="Tên sản phẩm"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  label="Tên sản phẩm"
                  :error="errors[0]"
                  v-model="info.name"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-upload
                :idUpload="'img-product' + type"
                :preview="uploadPreview"
                @doUpload="doUpload"
              ></base-upload>
            </b-col>
          </b-row>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng
        </button>
        <button type="button" @click="doSave(1)" class="btn btn-success">
          Lưu tiếp (Shift + F4)
        </button>
        <button type="submit" @click="doSave(0)" class="btn btn-dark">
          Lưu đóng (F4)
        </button>
      </ValidationObserver>
    </block>
    <event
      @doSave="doSave(0)"
      @doCancel="handleClose"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { productService, uploadService } from "@/_services";
export default {
  props: {
    type: {
      default: "ACTIVE"
    }
  },
  data() {
    return {
      visible: false,
      info: {},
      uploadPreview: "/img/placeholder/default.jpg"
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        self.info.type = self.type;
        if (self.info.id) {
          productService
            .update(self.info.id, self.info)
            .then(res => {
              self.ownInfo.name = res.data.name;
              self.ownInfo.avatar = res.data.avatar;
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              if (type == 0) {
                self.visible = false;
              }
              this.$refs.bmdal.unBlock();
            });
        } else {
          productService
            .create(self.info)
            .then(() => {
              self.$alertify.success("Thêm thành công");
              self.info = {
                quantity: 0,
                percentYarn: 0,
                percentLoss: 0,
                weight: 0,
                total_weight: 0
              };
              self.$emit("submit:success");
              if (type == 0) {
                self.visible = false;
              }
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              self.$refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(info) {
      if (info) {
        this.ownInfo = info;
        this.info = Object.assign({}, info);
        delete this.info.productSpecifys;
        if (this.info.avatar) {
          this.uploadPreview = this.$mediaURI + this.info.avatar;
        } else {
          this.uploadPreview = "/img/placeholder/default.jpg";
        }
      } else {
        this.uploadPreview = "/img/placeholder/default.jpg";
        this.info = {};
      }
    },
    handleClose() {
      this.visible = false;
    },
    doUpload(data, cb) {
      var self = this;
      this.uploadPreview = data.preview;
      uploadService.avatar({ file: data.file }).then(res => {
        self.info.avatar = res.data.path;
        cb();
      });
      console.log(data);
    }
  }
};
</script>
<style lang="scss">
.wrap-drop-img {
  height: 200px !important;
}
</style>
